import React, { useEffect, useState } from 'react';
import { Check, ChevronDown, Sparkles } from 'lucide-react';
import { Popover, PopoverContent, PopoverTrigger } from '@/components/ui/popover';
import { templateFilterTriggerStyle, templateFilterPanelStyle, templateFilterItemStyle } from '@/components/template-discover-styles';
import { nicheKey, type InspirationSelection } from './inspiration-filters';

export function InspirationFilterMenu({ open, onOpenChange, options, selected, onToggle }: {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  options: string[];
  selected: InspirationSelection[];
  onToggle: (value: string) => void;
}) {
  const [search, setSearch] = useState('');
  useEffect(() => { if (!open) setSearch(''); }, [open]);
  const filteredOptions = options.filter(option => nicheKey(option).includes(nicheKey(search)));
  return (
    <Popover open={open} onOpenChange={onOpenChange}>
      <PopoverTrigger asChild>
        <button type="button" data-testid="button-canvas-inspiration-filter" style={templateFilterTriggerStyle} onMouseEnter={event => { event.currentTarget.style.background = '#EAF0F7'; }} onMouseLeave={event => { event.currentTarget.style.background = 'transparent'; }}>
          <Sparkles size={12} />Inspiration<ChevronDown size={12} />
        </button>
      </PopoverTrigger>
      <PopoverContent data-testid="inspiration-filter-menu" aria-label="Inspiration filters" align="start" sideOffset={6} collisionPadding={20} onEscapeKeyDown={event => event.stopPropagation()} style={{ ...templateFilterPanelStyle, zIndex: 200, width: 'min(280px, calc(100vw - 40px))', padding: 0 }}>
        <div style={{ padding: '8px 10px', borderBottom: '1px solid #EAF0F7' }}>
          <input aria-label="Search inspiration options" value={search} onChange={event => setSearch(event.target.value)} placeholder="Search styles and angles…" style={{ width: '100%', padding: '5px 8px', borderRadius: 6, border: '1px solid #DCE3ED', background: '#F7F9FC', fontSize: 12, color: '#1A1A1A', outline: 'none', boxSizing: 'border-box' }} />
        </div>
        <div style={{ maxHeight: 'min(280px, var(--radix-popover-content-available-height))', overflowY: 'auto', padding: '4px 0' }}>
          {filteredOptions.map(option => {
            const isActive = selected.some(filter => nicheKey(filter.value) === nicheKey(option));
            return (
              <button key={option} type="button" aria-pressed={isActive} onClick={() => onToggle(option)} style={{ ...templateFilterItemStyle, justifyContent: 'space-between' }} onMouseEnter={event => { event.currentTarget.style.background = '#F1F5F9'; }} onMouseLeave={event => { event.currentTarget.style.background = 'transparent'; }}>
                <span>{option}</span>{isActive && <Check size={12} style={{ color: '#1A1A1A', flexShrink: 0 }} />}
              </button>
            );
          })}
          {!filteredOptions.length && <p style={{ padding: '8px 12px', fontSize: 12, color: '#5F6D82' }}>No matching inspiration</p>}
        </div>
      </PopoverContent>
    </Popover>
  );
}
